import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    storesGet,
    storesGetById,
    storesCreate,
    storesUpdate,
    storesDelete,
    requestStoresImport,
    geoLocationByPostalCode
} from "api/menu/master-files/stores/requests";

export const FETCH_STORES_LIST_SUCCESS = "FETCH_STORES_LIST_SUCCESS";
export const FETCH_STORE_BY_ID_SUCCESS = "FETCH_STORE_BY_ID_SUCCESS";
export const FETCH_GEOLOCATION_BY_POSTAL_CODE_SUCCESS = "FETCH_GEOLOCATION_BY_POSTAL_CODE_SUCCESS";

export const STORES_REQUEST_LOADING = "STORES_REQUEST_LOADING";
export const STORES_REQUEST_ERRORS = "STORES_REQUEST_ERRORS";

export const setLoading = () => ({
    type: STORES_REQUEST_LOADING
});

export const fetchStores = (retailerIdArr = [], provinceId = null, cityId = null) => dispatch => {
    dispatch(setLoading());
    storesGet(retailerIdArr, provinceId, cityId)
        .then(response => {
            dispatch({
                type: FETCH_STORES_LIST_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, STORES_REQUEST_ERRORS));
        });
};

export const fetchStoreById = (storeId) => dispatch => {
    storesGetById(storeId)
        .then(response => {
            dispatch({
                type: FETCH_STORE_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, STORES_REQUEST_ERRORS));
        });
};

export const insertStore = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    storesCreate(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Store "${data.storeNumber}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback(true);
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateStore = (storeId, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    storesUpdate(storeId, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Store "${data.storeNumber}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback(true);
            }
        })
        .catch(error => {
            dispatch(formErrorLoading(false));
            if (callback) {
                callback(error);
            }
        });
};

export const deleteStore = (storeId, storeNumber, callback = false) => dispatch => {
    dispatch(setLoading());
    storesDelete(storeId)
        .then(() => {
            toast(`Store "${storeNumber}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, STORES_REQUEST_ERRORS));
        });
};

export const clearStores = () => dispatch => {
    dispatch({
        type: FETCH_STORES_LIST_SUCCESS,
        payload: []
    });
};

export const clearSingleStore = () => dispatch => {
    dispatch({
        type: FETCH_STORE_BY_ID_SUCCESS,
        payload: {}
    });
};

export const storesImport = (data, callback) => dispatch => {
    dispatch(formErrorLoading());
    requestStoresImport(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            if (callback) {
                callback(true);
            }
            toast(`${data.stores.length} stores imported successfully`, {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(formErrorLoading(false));
            if (error && error.response && error.response.data) {
                callback(error.response.data);
                if (error.response.data.stores && Array.isArray(error.response.data.stores)) {
                    const totalCount = error.response.data.stores.length;
                    const isValidCount = error.response.data.stores
                        .filter(item => item.isValid).length;
                    toast(`${isValidCount} from ${totalCount} stores imported successfully`, {
                        type: toast.TYPE.SUCCESS,
                    });
                }
            }
        });
};


export const getGeoLocationByPostalCode = (postalCode) => dispatch => {
    dispatch(formErrorLoading());
    geoLocationByPostalCode(postalCode)
        .then(response => {
            if (response.data === "0,0") {
                dispatch(defaultErrorHandler({ message: `Unable to get coordinates for Postal Code ${postalCode}. Please check Postal Code and try again.` }, null, true));
            }
            dispatch({
                type: FETCH_GEOLOCATION_BY_POSTAL_CODE_SUCCESS,
                payload: response.data
            });

        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, STORES_REQUEST_ERRORS));
        }).finally(() => {
            dispatch(formErrorLoading(false));
        });
};
